/**
 * Created by Karan variya on 24/12/2018.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FeedbackComponent } from './feedback.page';
export const routes: Routes = [
    { path: 'feedback', component: FeedbackComponent }
];
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes)
    ],
    declarations: [FeedbackComponent]
})
export class FeedbackModule { }


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/feedback/feedback.module.ts